import { render } from "./ClozeExercise.vue?vue&type=template&id=34d4faad&ts=true"
import script from "./ClozeExercise.vue?vue&type=script&lang=ts"
export * from "./ClozeExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__